import { BodySmallTypography, Flex } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const InvoiceNameItemPrice = styled(Flex)`
  ${BodySmallTypography}
  color: ${({ theme }) => theme.colors.GREY_550};
  min-width: max-content;
  padding-left: 8px;
`
